import SHA256 from 'crypto-js/sha256';

// eslint-disable-next-line import/prefer-default-export
export const sha256 = async string => {
    const hash = SHA256(string);

    return hash.toString();
};
